import { getApi } from '@BUP/services/Axios'
import { useCourseAssignmentMutation } from './useCourseAssignmentMutation'

/**
 * Downloads one result version as an `.xlsx` (a "Resumen" sheet plus one sheet per resulting
 * course - built server-side, see the backend's buildResultVersionXlsx). Each saved set of moves is
 * its own version, so downloading the version on screen gives the file with those changes applied.
 */
const downloadResultXlsx = async ({ periodId, versionId, fileName }) => {
  const client = await getApi('schools', { authenticated: true, version: 5 })
  const { data } = await client.get(
    `/current-organization/course-assignment/periods/${periodId}/results/${versionId}/xlsx`,
    { responseType: 'blob' }
  )

  const url = URL.createObjectURL(data)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export const useDownloadResultXlsx = () => useCourseAssignmentMutation({
  mutationFn: downloadResultXlsx,
  hookName: 'useDownloadResultXlsx',
  errorMessage: 'Error downloading course assignment result (xlsx)'
})
